export const API_URLS = {
  // adminbaseURL: process.env.REACT_APP_ADMIN_URL,
  // baseURL: process.env.REACT_APP_BASE_URL,

  // adminbaseURL: "https://techugoapps.com:7109/v2/admin",
  // baseURL: "https://techugoapps.com:7109/student",
  adminbaseURL: "https://www.unigoal.com:7109/v2/admin",
  baseURL: "https://www.unigoal.com:7109/student",
  checkEmail: "/checkEmail",
  login: "/login",
  signup: "/signup",
  getInterestQuestionPaper: "/getInterestQuestionPaper",
  getAllDropdowns: "/getAllDropdowns",
  getPersonalityQuestionPaper: "/getPersonalityQuestionPaper",
  addInterestReport: "/addInterestReport",
  addAptitudeReport: "/addAptitudeReport",
  getAptitudeQuestionPaper: "/getAptitudeQuestionPaper",
  getSocialBehaviourReport: "/getSocialBehaviourReport",
  addSocialBehaviourReport: "/addSocialBehaviourReport",
  getSocialBehaviourQuestionPaper: "/getSocialBehaviourQuestionPaper",
  addStudentPersonalityReport: "/addStudentPersonalityReport",
};
